import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getDateAndHour, getIconInfoByTypeAndStatus, getStatusLabel } from '@/LabelTrackingPage/helpers'

import * as Styles from './styles'

const Status = ({ info }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const iconInfo = getIconInfoByTypeAndStatus(info?.type, info?.status, theme)
  const statusLabel = getStatusLabel(info?.type, info?.status, info?.delivery_method?.type)
  const { date, hour } = getDateAndHour(info, i18n.language, info?.status, info?.address?.country?.timezone)

  return (
    <Styles.Container>
      {iconInfo && (
        <Styles.StatusIconContainer
          backgroundColor={info?.is_alert ? theme.colors.orange.tone500 : iconInfo?.backgroundColor}
        >
          <iconInfo.icon size={24} color={iconInfo?.color} />
        </Styles.StatusIconContainer>
      )}
      <Styles.StatusAndDateContainer>
        <Text type="titleL">{t(statusLabel)}</Text>
        <Text type="allCapsM" customStyles={{ textTransform: 'uppercase' }}>
          {date} · {hour}
        </Text>
      </Styles.StatusAndDateContainer>
    </Styles.Container>
  )
}

export default Status
